import React, { useMemo } from "react";
import ReactECharts from "echarts-for-react";
import { Box } from "@mui/material";
import moment from "moment";
import { analysisColors } from "features/configure/chartColors";
import { formatDate } from "features/helpers/utils";
import EmptyIconStatus from "components/EmptyState/EmptyIconStatus";
import { Loading } from "features/common";
import { useIntl } from "react-intl";

const LineChart = ({ performance, isShowObjective, isLoading }) => {
  const { formatMessage } = useIntl();
  const colors = analysisColors.small;

  const option = useMemo(() => {
    const legendData = ["Wallets Connected", "Total User"];
    const series = [
      {
        name: "Wallets Connected",
        type: "line",
        smooth: true,
        data: performance.map((x) => x.walletsConnected),
        showSymbol: false,
      },
      {
        name: "Total User",
        type: "line",
        smooth: true,
        data: performance.map((x) => x.totalUser),
        showSymbol: false,
      },
    ];

    if (isShowObjective) {
      legendData.push("Objective Achieved");
      series.push({
        name: "Objective Achieved",
        type: "line",
        smooth: true,
        data: performance.map((x) => x.objectiveAchieved),
        showSymbol: false,
      });
    }

    return {
      tooltip: {
        trigger: "axis",
      },
      grid: {
        left: 0,
        // top: 0,
        right: 0,
        bottom: 0,
        containLabel: true,
      },
      legend: {
        orient: "horizontal",
        left: "left",
        data: legendData,
      },
      xAxis: {
        type: "category",
        data: performance.map((x) => x.date),
        axisLabel: {
          formatter: (value) => formatDate(value, { month: true }),
        },
      },
      yAxis: {
        type: "value",
      },
      series: series.map((s, idx) => ({
        ...s,
        itemStyle: { color: colors[idx] },
        lineStyle: { color: colors[idx] },
      })),
    };
  }, [performance, isShowObjective]);

  return (
    <Box
      sx={{
        height: "100%",
        flex: 1,
        bgcolor: "#fff",
        borderRadius: 1,
        p: 2,
      }}>
      <Box
        sx={{
          fontSize: "16px",
          fontWeight: 500,
          color: (theme) => theme.customColors.grey[700],
        }}>
        {formatMessage({ id: "websiteTraffic.chart.walletConnected" })}
      </Box>
      <Box sx={{ height: "288px" }}>
        {isLoading ? (
          <Box sx={{ position: "relative", height: "100%" }}>
            <Loading open={true} fullScreen={false} isChart={true} />
          </Box>
        ) : performance.length > 0 ? (
          <ReactECharts
            option={option}
            style={{ height: "100%", width: "100%", padding: "12px" }}
          />
        ) : (
          <EmptyIconStatus
            icon="chart"
            sx={{ height: "100%", width: "100%" }}
          />
        )}
      </Box>
    </Box>
  );
};

export default LineChart;
